import type {
  ChatbotVoiceSettings,
  ChatbotVoiceSettingsUpdateInput,
} from "@chat-yai/shared/voice-types";
import { request } from "@/api/client";

export const voiceSettingsApi = {
  get(chatbotId: string) {
    return request<ChatbotVoiceSettings>(
      `/admin/chatbots/${chatbotId}/voice`,
    );
  },
  update(chatbotId: string, input: ChatbotVoiceSettingsUpdateInput) {
    return request<ChatbotVoiceSettings>(
      `/admin/chatbots/${chatbotId}/voice`,
      { method: "PATCH", body: input },
    );
  },
};
